import { connect as formikConnect } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import * as Globals from '../../../../tools/Globals';

import FormAutocompleteOption from './FormAutocompleteOption';
import * as KeyBindings from './KeyBindings';

import './FormAutocomplete.scss';

const INITIAL_OPTION_INDEX = -1;
const CLICK_EVENT = 'click';

class FormAutocomplete extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    options: PropTypes.array,
    error: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    formik: PropTypes.object.isRequired,
    inputAttributes: PropTypes.object.isRequired,
    labelText: PropTypes.string,
  };

  static defaultProps = {
    options: [],
  };

  constructor(props) {
    super(props);

    this.inputRef = React.createRef();
    this.state = {
      isOptionsDisplayed: false,
      displayedValue: '',
      focusedItem: {},
      focusedItemIndex: INITIAL_OPTION_INDEX,
    };

    Globals.addDocumentEventListener(CLICK_EVENT, this.handleGlobalClick);
  }

  componentWillUnmount = () => {
    Globals.removeDocumentEventListener(CLICK_EVENT, this.handleGlobalClick);
  };

  handleGlobalClick = event => {
    if (event.target !== this.inputRef.current) {
      this.closeDropdown();
    }
  };

  bindKeys = () => {
    const { moveUp, moveDown, selectItem, closeDropdown } = this;

    KeyBindings.bindKeys({ moveUp, moveDown, selectItem, closeDropdown });
  };

  unbindKeys = () => {
    KeyBindings.unbindKeys();
  };

  resetFocusedItemIndex = () => {
    this.setState({
      focusedItemIndex: INITIAL_OPTION_INDEX,
    });
  };

  handleSelectItem = ({ label, value }) => {
    const { formik, inputAttributes } = this.props;

    this.setState({ displayedValue: label });
    formik.setFieldValue(inputAttributes.name, value, true);
    this.inputRef.current.focus();
    this.closeDropdown();
  };

  handleChange = e => {
    const label = e.target.value;

    this.setState({
      displayedValue: label || '',
      isOptionsDisplayed: label.length > 0,
    });

    this.props.onChange(label);
  };

  setFocusedItem = item => {
    this.setState({ focusedItem: item });
  };

  selectItem = e => {
    e.preventDefault();
    this.handleSelectItem(this.state.focusedItem);
  };

  moveDown = e => {
    e.preventDefault();

    this.setState((state, props) => {
      const { focusedItemIndex } = this.state;

      if (focusedItemIndex < props.options.length - 1) {
        return {
          focusedItemIndex: focusedItemIndex + 1,
        };
      }
    });
  };

  moveUp = e => {
    e.preventDefault();

    this.setState(state => {
      const { focusedItemIndex } = this.state;

      if (focusedItemIndex > 0) {
        return {
          focusedItemIndex: focusedItemIndex - 1,
        };
      }
    });
  };

  closeDropdown = () => {
    this.resetFocusedItemIndex();
    this.setState({ isOptionsDisplayed: false });
  };

  handleFocus = () => {
    this.resetFocusedItemIndex();
    this.bindKeys();

    this.setState((state, props) => {
      return {
        isOptionsDisplayed: props.options.length > 0 ? true : state.isOptionsDisplayed,
      };
    });
  };

  shouldShowOptionsList = () => {
    return this.props.options.length > 0 && this.state.isOptionsDisplayed;
  };

  render() {
    const { error, options, placeholder } = this.props;

    return (
      <div className='Form__autocomplete'>
        <input
          className='Form__autocomplete__input'
          value={this.state.displayedValue}
          onChange={this.handleChange}
          type='text'
          autoComplete='off'
          placeholder={placeholder}
          onFocus={this.handleFocus}
          onBlur={this.unbindKeys}
          ref={this.inputRef}
        />
        {this.shouldShowOptionsList() && (
          // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
          <ol
            onFocus={this.bindKeys}
            onBlur={this.unbindKeys}
            className='Form__autocomplete__options'
          >
            {' '}
            {options.map((option, i) => (
              <FormAutocompleteOption
                shouldFocus={i === this.state.focusedItemIndex}
                onChange={this.handleSelectItem}
                onFocus={this.setFocusedItem}
                value={option.value}
                label={option.label}
                key={option.value}
              />
            ))}{' '}
          </ol>
        )}

        {<div>{error}</div>}
      </div>
    );
  }
}

export default formikConnect(FormAutocomplete);
